import React from "react";
import Chip from "@mui/material/Chip";

type CreatedVia =
  | "web"
  | "ios"
  | "desktop"
  | "ai"
  | "api"
  | "system"
  | "script"
  | "import"
  | "unknown"
  | null
  | undefined;

const LABELS: Partial<Record<NonNullable<CreatedVia>, string>> = {
  web: "Web",
  ios: "iOS",
  desktop: "Desktop",
  ai: "AI",
  api: "API",
  system: "Auto",
  script: "Script",
  import: "Import",
};

interface CreatedViaBadgeProps {
  createdVia?: CreatedVia;
}

const CreatedViaBadge: React.FC<CreatedViaBadgeProps> = ({ createdVia }) => {
  if (!createdVia) return null;
  const label = LABELS[createdVia];
  if (!label) return null;

  return (
    <Chip
      label={label}
      size="small"
      variant="outlined"
      sx={{
        height: 18,
        fontSize: "0.65rem",
        opacity: 0.7,
        "& .MuiChip-label": { px: 0.75 },
      }}
    />
  );
};

export default CreatedViaBadge;
